import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'opencare-crown';

import { FlexRow, P, VisuallyHidden } from 'common/styles/oc-styled-components';
import { ratingColors } from 'common/styles/style-constants';

import { Star, WidthP } from './styled-components';

function ReviewBreakdown({ rating, numberOfReviews, total }) {
  const color = ratingColors[rating];
  const percent = numberOfReviews / total * 100;

  return (
    <div>
      <VisuallyHidden>{`${numberOfReviews} ${rating}-star review${
        numberOfReviews === 1 ? '' : 's'
      }`}</VisuallyHidden>
      <FlexRow margin="8px 0 4px 0" aria-hidden>
        <FlexRow align="center" margin="0 5px 0 0">
          <P color={color} margin="0 5px 0 0">
            {rating}
          </P>
          <Star color={color} type="star" theme="filled" />
        </FlexRow>
        <Progress
          strokeColor={color}
          type="line"
          // Prevent visual bug with low percentages
          percent={percent < 3 && percent !== 0 ? 3 : percent}
          showInfo={false}
          strokeWidth={20}
        />
        <WidthP margin="0 0 0 8px">{numberOfReviews}</WidthP>
      </FlexRow>
    </div>
  );
}

ReviewBreakdown.propTypes = {
  numberOfReviews: PropTypes.number,
  rating: PropTypes.number,
  total: PropTypes.number,
};

export default ReviewBreakdown;
